<script lang="ts">
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { executeModeReplacement } from '../../../../helpers/mode_switch_helpers';
	import {
		checkSharedChannels,
		unshareAllChannels,
		type SharedChannelData,
	} from '../../../../helpers/profile_change_shared_helper';
	//Services
	import { format } from 'svelte-i18n';
	import { location } from 'svelte-spa-router';
	import { postReq, localReq } from '../../../../services/http';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { app } from 'src/stores/session/native-bridge';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	//Components
	import ProfileChangeSharedModal from '../SettingsG2/ProfileChangeSharedModal.svelte';

	export let device;

	let settings = readDeviceSettings(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;
	let mode = settings?.mode;
	let cacheMode = mode;
	let localIp = get_local_ip(device.id);
	let loading = false;
	let showModal: boolean = false;
	let sharedChannelsData: SharedChannelData[] = [];

	const modes = ['relay', 'roller'];
	const options = [
		$format('option_mode_relay', {
			default:
				'Relay - this mode has ON and OFF states, it is applicable for various appliances such as Lights, Sockets, etc.',
		}),
		$format('option_mode_roller', {
			default:
				'Roller Shutter - this mode is usable for different variants of Door and Windows Rollers. It supports UP, DOWN and STOP commands and provides different settings.',
		}),
	];

	const setMode = (_mode) => {
		mode = _mode;
	};

	const handleSave = async () => {
		if (cacheMode === mode) return;
		await proceedToRequest();
	};

	const proceedToRequest = async () => {
		const channelsData = await checkSharedChannels(device);

		if (channelsData.length > 0) {
			sharedChannelsData = channelsData;
			showModal = true;
			return;
		}

		await sentRequest();
	};

	const sentRequest = async () => {
		if (cacheMode !== mode) {
			let res: SettingRequest;
			loading = true;
			showModal = false;

			await unshareAllChannels(sharedChannelsData);

			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					mode: mode,
				});
			} else {
				res = await postReq(`/device/relay/settings/change_mode`, {
					id: real_id(device.id),
					mode: mode,
				});
			}

			if (res.isok) {
				// copy the device data so as not to update before init
				const _device = Object.assign({}, { ...device });

				if (mode === 'relay') {
					await executeModeReplacement(_device, 'relay', 'category', true);
				} else if (mode === 'roller') {
					await executeModeReplacement(_device, 'roller', 'category', false);
					//TODO need to test why cannot create new device(response is {err_perm: "No permissions."})

					// if in second cahnnel channel rout the user to the 1st one (roller is 1 channel)
					// if (device.channel > 0) {
					// 	replace(`/device/${real_id(device.id)}`);
					// }

					if (device.channel !== 0) {
						if ($app) {
							//Looking for app because on desktop we have secondary attempt of closing drawer
							setSidePanelState({
								open: false, //Closing this drawer because need to remove secondary controls tab
							});
						} else {
							const roomId = $location.split('/')[3]; //equal behavior like rgbw 2 mode change
							setSidePanelState({
								type: 'room',
								id: roomId,
							});
						}
					}
				}
				cacheMode = mode;
			} else {
				mode = cacheMode;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			loading = false;
		}
	};
</script>

{#each modes as _mode, i}
	<Radio
		size="m"
		selected={mode}
		value={_mode}
		on:click={() => {
			setMode(_mode);
		}}
		id="radio-l22g5c1">{options[i]}</Radio
	>
{/each}

{#if sharedChannelsData.length > 0}
	<ProfileChangeSharedModal bind:showModal on:confirm={sentRequest} />
{/if}

<Button class="mt-s" {loading} size="m" width="full" on:click={handleSave}
	>{$format('button_save')}</Button
>
